import {
  ConversationId,
  ConversationIdRestricted,
} from 'components/conversation/conversationId';

import { useConversationRow } from '../../../utils/useConversationRow';

/** Represents the content of the csid cell in the conversations table. */
export const ConversationsTableCsid = (): JSX.Element => {
  const {
    conversationAndRequester: { conversation },
    isRestricted,
  } = useConversationRow();

  return isRestricted ? (
    <ConversationIdRestricted csid={conversation.id} />
  ) : (
    <ConversationId csid={conversation.id} />
  );
};
